<template>
  <div class="menu">
    <v-menu
      bottom
      offset-y
      open-on-hover
      nudge-left="60"
    >
      <template v-slot:activator="{ on }">
        <v-icon
          class="setting-icon"
          color="metalGreyDark"
          v-on="on"
        >
          mdi-cog
        </v-icon>
      </template>
      <v-list>
        <v-list-tile
          class="menu-item"
        >
          <span
            style="color: crimson"
            @click="showDialog = true"
          >
            <v-icon
              class="mr-2"
              color="error"
            >
              mdi-account-minus
            </v-icon>
            顧客削除
          </span>
        </v-list-tile>
      </v-list>
    </v-menu>
    <ConfirmDialog
      v-model="showDialog"
      :disabled="!checked"
      class="pa-3"
      @confirm="deleteCustomerHandler"
      @cancel="showDialog = false"
    >
      <h2 class="my-2 text-xs-center headline">
        下記の顧客を削除します。
      </h2>
      <template>
        <v-data-table
          :headers="headers"
          :items="[customer]"
          class="my-3"
          hide-actions
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ props.item.code }}
            </td>
            <td class="text-xs-center">
              {{ props.item.name }}
            </td>
            <td class="text-xs-center">
              {{ props.item.areaName }}
            </td>
            <td class="text-xs-center">
              {{ props.item.sensors.length > 0 ? "あり" : "なし" }}
            </td>
          </template>
        </v-data-table>
      </template>
      <div class="mb-4">
        <p class="px-3 mb-0 mt-2">
          顧客データと関連するデータが<span class="red--text font-weight-bold">全て削除されます</span>。
        </p>
        <p class="px-2 mb-0">
          （この操作はやり直しできません。）
        </p>
      </div>
      <div
        v-if="errorMessage"
        class="error-text"
      >
        ・{{ errorMessage }}
      </div>
      <v-checkbox
        v-model="checked"
        label="完全に削除する"
        color="red"
        class="unselect-checkbox checking font-weight-black black--text"
      />
    </ConfirmDialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { ConfirmDialog } from '@/components/dialog'

export default {
  name: 'CustomerMenu',
  components: {
    ConfirmDialog
  },
  props: {
    customer: {
      type: Object,
      default: () => null
    }
  },
  data () {
    const headerClass = 'text-xs-center font-weight-bold body-2'
    return {
      showDialog: false,
      checked: false,
      loading: false,
      errorMessage: '',
      headers: [
        { text: '顧客番号', value: 'code', sortable: false, class: headerClass },
        { text: '名称', value: 'name', sortable: false, class: headerClass },
        { text: 'エリア', value: 'area', sortable: false, class: headerClass },
        { text: 'センサー', value: 'sensors[0]', sortable: false, class: headerClass }
      ]
    }
  },
  methods: {
    ...mapActions('customers', ['deleteCustomer']),
    async deleteCustomerHandler () {
      this.loading = true
      try {
        await this.deleteCustomer(this.customer)
      } catch (err) {
        this.errorMessage = err.response?.body?.errorMessage || 'エラーにより削除できませんでした。'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.menu {
  display: flex;
  align-items: center;
}
.menu-item{
  cursor: pointer;
  &:hover{
    background: rgba(0, 0, 0, 0.021);
  }
}
.setting-icon{
  cursor: pointer;
}
.checking {
  position: absolute;
  top: 99.5%;
  left: 12%;
  padding: 5px;
}
.error-text {
  position: absolute;
  right: 10px;
  bottom: 0px;
  word-wrap: break-word;
  max-width: 65%;
  color: red;
  font-size: 0.8rem;
  font-weight: bold;
  pointer-events: none;
  text-align: right;
}
</style>
